import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { AppBar } from './components/AppBar';
import Footer from './components/Footer';
import { Col, Container, Row } from 'react-bootstrap';
import { Buttons } from '../components/Buttons/Buttons';
import { useNavigate } from 'react-router-dom';
import Carousal from './components/Carousal';
import MetaTags from './components/MetaTags';

const About = () => {
  const navigate = useNavigate();
  const handlenavigate = () => {
    navigate('/');
  };

  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 1000,
      easing: 'ease-out-cubic',
      once: true,
    });
  }, []);

  return (
    <>
      <MetaTags
        title="About Us | Alagar Crackers Sivakasi - Direct Factory Fireworks"
        type="website"
        siteName="alagarcrackers.com"
        url="https://alagarcrackers.com/about"
        keywords="About Alagar Crackers, Sivakasi Crackers wholesale, Fireworks factory Sivakasi"
        description="Learn more about Alagar Crackers, the premier fireworks provider in Sivakasi."
        revisitAfter="10 Days"
      />
      <AppBar />
      <img src={require('../assets/images/banner/banner_onethree.jpg')} className='img-fluid w-100' alt='About Alagar Crackers' />

      <div className='padding'>
        <Container>
          <Row className='justify-content-center align-items-center'>
            <Col lg='7' className='py-3'>
              <div className='d-inline-block px-3 py-1 bg-danger bg-opacity-10 text-danger rounded-pill fw-bold mb-3' style={{ fontSize: '13px' }}>
                ✨ SIVAKASI DIRECT WHOLESALE & RETAIL
              </div>
              <h2 className='bold lg-font color-red mb-4'>Welcome to Alagar Crackers</h2>
              <div className='regular text-muted' style={{ fontSize: '16px', lineHeight: 1.8 }}>
                <p>
                  Welcome to <strong>Alagar Crackers</strong>, your premier destination for high-quality fireworks and crackers available at both retail and wholesale factory rates! Sourced directly from the fireworks capital of India, Sivakasi, we provide a breathtaking array of sparkling fireworks that bring color, joy, and unforgettable excitement to every celebration.
                </p>
                <p>
                  From grand Diwali festivals and New Year celebrations to weddings, anniversaries, and family festivities, our curated catalog of 200+ varieties ensures safe, vibrant, and long-lasting effects.
                </p>
                <p>
                  Every order is packed with stringent safety protocols and shipped through legal, certified transport operators to ensure hassle-free doorstep reach across the country.
                </p>
              </div>
            </Col>
            <Col lg="5" className='py-3 text-center'>
              <div className='p-4 bg-white rounded-4 shadow-sm border'>
                <img src={require('../assets/images/storelogo.png')} className='img-fluid' style={{ maxWidth: '240px' }} alt='Alagar Crackers Store Logo' />
                <h5 className='bold mt-3 text-dark'>Alagar Fireworks Agencies</h5>
                <p className='regular text-muted small mb-0'>Serving Quality Fireworks for Over a Decade</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Callout Counter Banner */}
      <div className='counter padding bg-overlay z text-center'>
        <Container>
          <Row className='justify-content-center'>
            <Col lg="10" className='py-4 z text-white'>
              <h3 className='bold mb-3' style={{ fontSize: '28px' }}>
                Handpicked Cracker Varieties at Unbeatable Sivakasi Direct Rates!
              </h3>
              <p className='regular text-white-50 mb-4' style={{ fontSize: '16px' }}>
                Explore sparklers, flowerpots, multi-color sky shots, chakkars, and grand gift boxes with huge flat discounts.
              </p>
              <Buttons label={<>🔥 Check Today's Price List</>} onClick={handlenavigate} />
            </Col>
          </Row>
        </Container>
      </div>

      {/* Brands Carousel Section */}
      <div className='padding bg-white'>
        <Container>
          <Row>
            <Col lg="12" className='text-center mb-4'>
              <h2 className='bold color-red'>Our Partner Brands & Manufacturers</h2>
              <p className='regular text-muted'>We deal only in authorized, standard branded fireworks with certified safety formulations.</p>
            </Col>
            <Col lg="12">
              <Carousal />
            </Col>
          </Row>
        </Container>
      </div>

      {/* Vision & Mission */}
      <img src={require('../assets/images/banner/banner_onefour.jpg')} className='img-fluid w-100' alt='Vision and Mission' />
      <div className='padding' style={{ backgroundColor: '#fff8f6' }}>
        <Container>
          <Row className='g-4'>
            <Col lg='6' xs='12'>
              <div className='p-4 p-md-5 bg-white rounded-4 shadow-sm h-100 border-start border-4 border-danger'>
                <h3 className='bold color-red mb-3'>🎯 Our Vision</h3>
                <p className='regular text-muted' style={{ lineHeight: 1.8, fontSize: '16px' }}>
                  To be India's most trusted, transparent, and preferred wholesale and retail partner for premium fancy fireworks, novelty crackers, and festive gift boxes.
                </p>
              </div>
            </Col>
            <Col lg='6' xs='12'>
              <div className='p-4 p-md-5 bg-white rounded-4 shadow-sm h-100 border-start border-4 border-warning'>
                <h3 className='bold text-warning mb-3'>🚀 Our Mission</h3>
                <p className='regular text-muted' style={{ lineHeight: 1.8, fontSize: '16px' }}>
                  To deliver genuine, factory-fresh Sivakasi crackers with maximum safety, eco-friendly formulations, and affordable prices, ensuring unmatched happiness for every family.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default About;